import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { SidebarContextProvider } from './setup/sidebarContext';
import { LangContextProvider } from './setup/langContext';
import { ThemeContextProvider } from './setup/themeContext';
import { Provider } from 'react-redux';
import { store } from './setup/store';
import SnackBar from 'components/snack-bar';
import { CustomThemeProvider } from 'setup/themeContextMaterial';

ReactDOM.render(
  <LangContextProvider>
    <Provider store={store}>
      {/* <LoginContextProvider> */}
      <ThemeContextProvider>
        <CustomThemeProvider>
          <SidebarContextProvider>
            <>
              <App />
              {/* <AppInit /> */}
              <SnackBar />
            </>
          </SidebarContextProvider>
        </CustomThemeProvider>
      </ThemeContextProvider>
      {/* </LoginContextProvider> */}
    </Provider>
  </LangContextProvider>,
  document.getElementById('root'),
);
